 <template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>

    <filter-orders></filter-orders>

      <table class="ls-table ls-sm-space ls-table-striped" v-if="orders.length">
        <thead>
          <tr>
            <th>{{ $t('orders.attributes.transaction') }}</th>
            <th>{{ $t('orders.attributes.contract') }}</th>
            <th>{{ $t('orders.attributes.status') }}</th>
            <th>{{ $t('orders.attributes.customer') }}</th>
            <th>{{ $t('orders.attributes.payment_method_type') }}</th>
            <th>{{ $t('orders.attributes.price') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders">
            <td>
              {{ order.id }} <br>
              {{ date.parseDate(order.created_at) }}
            </td>
            <td>
              <authorized-link tag="show_invoice">
                #ID Fatura:
                <router-link :to="{ name: 'invoice_details', params: {invoice_id: order.invoice_token} }">{{ order.invoice_id }}</router-link>
              </authorized-link>
              <br>
              {{ $t('orders.attributes.contract_code') }}: {{ order.contract_code }}
            </td>
            <td v-bind:class="mountTag(order.status)">
              <div>
                {{ $t('orders.status.' + order.status)  }}
              </div>
            </td>
            <td>
              {{ order.customer.name }}<br>
              {{ order.customer.email }}
            </td>
            <td>
              {{ $t('orders.type.' + order.payment_method_type) }}
            </td>
            <td>
              R$ {{ money.parseViewValue(order.price) }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else role="alert">
          <empty-list></empty-list>
        </div>
      <pagination :updater="loadOrders"></pagination>
   </div>
  </template>

  <script>
  import { mapActions, mapGetters } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import Pagination from 'src/app/components/shareds/pagination/Pagination'
  import Filter from './components/Filter'
  import Browser from 'src/utils/browser'
  import EmptyList from 'src/app/components/shareds/empty-list/EmptyList'

  import date from 'src/utils/date'
  import money from 'src/utils/money'
  import filter from 'src/utils/filter'

  export default {
    name: 'IndexOrders',
    components: {
      Breadcrumb,
      Pagination,
      EmptyList,
      FilterOrders: Filter
    },
    mounted () {
      this.getFromUrl()
      this.loadOrders()
    },
    data () {
      return {
        date: date,
        money: money,
        filters: [
        ],
        crumbs: {
          'ico': 'ls-ico-shaft-up',
          'section': this.$t('orders.main.breadcrumb_title'),
          'paths': {
            0: {
              'title': this.$t('orders.main.breadcrumb_path'),
              'path': ''
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters(['orders', 'pagination'])
    },
    methods: {
      ...mapActions(['getOrders']),
      loadOrders () {
        this.saveOnUrl()
        this.$loader.show()
        let params = filter.toQueryWithPagination(this.filters, this.pagination, 10)
        this.getOrders(params).then(() => { this.$loader.hide() })
      },
      getFromUrl () {
        Browser.recoverFilterFromURL(this.$route, this.filters, this.pagination)
      },
      saveOnUrl () {
        var paginationUrlParams = { current_page: this.pagination.current_page, per_page: this.pagination.per_page }
        Browser.filtersToURL(this.$router, Object.assign(paginationUrlParams, this.filters), 'orders')
      },
      mountTag (status) {
        if (status === 'not_paid') {
          return 'canceled'
        }

        if (status === 'pending' || status === 'awaiting_approval') {
          return 'pending'
        }

        if (status === 'paid') {
          return 'active'
        }
      }
    }
  }
  </script>
  <style lang="scss">
  .total-item {
    text-align: center;
    position: relative;
    top: 36px;
    margin: 0;
    @media (max-width: 960px) {
      top: 0;
    }
  }
  .inactive {
    background: #f2f2f2!important;
    color: #8c8c8c;
  }
  .active {
    background-color: #b2e1b3!important;
    color: #388f39;
  }
  </style>



// WEBPACK FOOTER //
// Main.vue?e9257af8